import ApiService from "@/common/api.service";
import { FETCH_ECOMM_DISPLAY_NAMES } from "./actions.type";
import {
    FETCH_START_ECOMM_DISPLAY_NAMES,
    FETCH_END_ECOMM_DISPLAY_NAMES
} from "./mutations.type";

const state = {
    ecommDisplayNames: [],
    isLoading: false,
    lastFetched: null
};

const getters = {
    ecommDisplayNames(state) {
        return state.ecommDisplayNames;
    },
    isLoadingEcommDisplayNames(state) {
        return state.isLoading;
    },
    // Get ecomm display name by service ID
    getEcommDisplayName: (state) => (serviceId) => {
        if (!serviceId) return null;
        const id = typeof serviceId === 'string' ? parseInt(serviceId) : serviceId;
        const service = state.ecommDisplayNames.find((s) => s.id === id);
        return service ? (service.ecomm_display || service.service_name) : null;
    },
    // Get service name by ID
    getServiceName: (state) => (serviceId) => {
        if (!serviceId) return null;
        const id = typeof serviceId === 'string' ? parseInt(serviceId) : serviceId;
        const service = state.ecommDisplayNames.find((s) => s.id === id);
        return service ? service.service_name : null;
    },
    // Get full service object by ID
    getServiceById: (state) => (serviceId) => {
        if (!serviceId) return null;
        const id = typeof serviceId === 'string' ? parseInt(serviceId) : serviceId;
        return state.ecommDisplayNames.find((s) => s.id === id) || null;
    },
    // Get ecomm display name by service name (fallback method)
    getEcommDisplayNameByName: (state) => (serviceName) => {
        if (!serviceName) return null;
        const service = state.ecommDisplayNames.find(
            (s) => s.service_name === serviceName
        );
        return service ? (service.ecomm_display || service.service_name) : null;
    }
};

const actions = {
    [FETCH_ECOMM_DISPLAY_NAMES]({ commit }) {
        commit(FETCH_START_ECOMM_DISPLAY_NAMES);
        return ApiService.get("/public/ecomm-display-names")
            .then(({ data }) => {
                const services = data.services || [];
                commit(FETCH_END_ECOMM_DISPLAY_NAMES, services);
                return services;
            })
            .catch((error) => {
                console.error("Error fetching ecomm display names:", error);
                commit(FETCH_END_ECOMM_DISPLAY_NAMES, []);
                throw new Error(error);
            });
    }
};

const mutations = {
    [FETCH_START_ECOMM_DISPLAY_NAMES](state) {
        state.isLoading = true;
    },
    [FETCH_END_ECOMM_DISPLAY_NAMES](state, services) {
        state.ecommDisplayNames = services;
        state.isLoading = false;
        state.lastFetched = new Date().getTime();
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
